import AppFooter from './AppFooter.vue';

export default AppFooter;
